import { render } from "./GuardiaFaramirView.vue?vue&type=template&id=5c08bb01&scoped=true"
import script from "./GuardiaFaramirView.vue?vue&type=script&lang=js"
export * from "./GuardiaFaramirView.vue?vue&type=script&lang=js"

import "./GuardiaFaramirView.vue?vue&type=style&index=0&id=5c08bb01&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c08bb01"]])

export default __exports__